// Unified Dark Mode Script for ChainWorthy
// This replaces both dark-mode.js and dark-mode-enhanced.js
(function() {
    const THEME_KEY = 'chainworthy-theme'; // Single source of truth
    
    // Get saved theme or detect system preference
    function getTheme() {
        // Check for old key and migrate if needed
        const oldTheme = localStorage.getItem('color-theme');
        if (oldTheme && !localStorage.getItem(THEME_KEY)) {
            localStorage.setItem(THEME_KEY, oldTheme);
            localStorage.removeItem('color-theme');
        }
        
        const saved = localStorage.getItem(THEME_KEY);
        if (saved) return saved;
        
        return window.matchMedia('(prefers-color-scheme: dark)').matches 
            ? 'dark' 
            : 'light';
    }
    
    // Apply theme immediately (before page renders)
    function applyTheme(theme) {
        if (theme === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
        localStorage.setItem(THEME_KEY, theme);
    }
    
    // Initialize on load
    const theme = getTheme();
    applyTheme(theme);
    
    // Setup toggle function for button
    window.toggleDarkMode = function() {
        const current = localStorage.getItem(THEME_KEY) || 'light';
        const next = current === 'dark' ? 'light' : 'dark';
        applyTheme(next);
        
        // Update button icons
        updateIcons(next);
        
        // Dispatch custom event for components to react
        window.dispatchEvent(new CustomEvent('theme-changed', { 
            detail: { theme: next } 
        }));
    };
    
    // Update button icons based on theme
    function updateIcons(theme) {
        const darkIcon = document.getElementById('theme-toggle-dark-icon');
        const lightIcon = document.getElementById('theme-toggle-light-icon');
        
        if (darkIcon && lightIcon) {
            if (theme === 'dark') {
                darkIcon.classList.add('hidden');
                lightIcon.classList.remove('hidden');
            } else {
                lightIcon.classList.add('hidden');
                darkIcon.classList.remove('hidden');
            }
        }
    }
    
    // Initialize button icons and attach click handler when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            const currentTheme = getTheme();
            updateIcons(currentTheme);
            
            const toggleBtn = document.getElementById('theme-toggle');
            if (toggleBtn) {
                toggleBtn.addEventListener('click', window.toggleDarkMode);
            }
        });
    } else {
        // DOM already loaded
        const currentTheme = getTheme();
        updateIcons(currentTheme);
        
        const toggleBtn = document.getElementById('theme-toggle');
        if (toggleBtn) {
            toggleBtn.addEventListener('click', window.toggleDarkMode);
        }
    }
})();